const DOCUMENT_TYPE_OPTIONS = [
  { text: 'Bank Loan Document', value: 'bank_loan_document' },
  { text: 'Identity', value: 'identity' },
  { text: 'Installment Payment', value: 'installment_payment' },
  { text: 'Other Documents', value: 'other_documents' },
  { text: 'Registration of Interest', value: 'registration_of_interest' },
  { text: 'Token Payment', value: 'token_payment' },
  { text: 'Token Refund', value: 'token_refund' },
  { text: 'Token Payment Receipt', value: 'token_payment_receipt' },
];

// CPI-1249: the four types below are generated by the system (the sales form book-api files
// against the opportunity, the banker copy, and the bank-package pair), so they must NOT appear
// in the upload dropdown - DOCUMENT_TYPE_OPTIONS above stays the only source for that. They do
// have to be nameable, otherwise a generated file shows its Type as the literal "N/A".
// These are the remaining four of book-api's twelve `ValidFileTypes`
// (mhub-book-api models/shared_media.go).
export const DOCUMENT_TYPE_LABELS = [
  ...DOCUMENT_TYPE_OPTIONS,
  { text: 'Opportunity Form', value: 'opportunity_form' },
  { text: 'Banker Opportunity Form', value: 'banker_opportunity_form' },
  { text: 'Bank Package Form', value: 'bank_package_form' },
  { text: 'Bank Package Image', value: 'bank_package_image' },
];

// getDocumentTypeLabel returns the untranslated label for a backend file_type, or null when the
// value is unknown (an empty string, or a type added to book-api and not yet to this list). The
// caller decides what to render for null - the Documents tab shows a translated "N/A".
export const getDocumentTypeLabel = (fileType) => {
  if (!fileType) return null;
  const option = DOCUMENT_TYPE_LABELS.find(opt => opt.value === fileType);
  return option ? option.text : null;
};

export default DOCUMENT_TYPE_OPTIONS;



// WEBPACK FOOTER //
// ./src/constants/documentType.js